<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        Envío de variaciones de jornada y pluses a Endalia
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="nombreEmpresa"
              :items="empresas"
              label="Empresa"
              outlined
              dense
              clearable
              :disabled="loading"
            />
          </v-col>

          <v-col cols="12" md="4">
            <v-checkbox
              v-model="guardarHistorico"
              label="Guardar datos en histórico"
              :disabled="loading"
              dense
            />
          </v-col>

          <v-col cols="12" md="3" class="d-flex align-center">
            <v-btn
              color="primary"
              :loading="loading"
              :disabled="!nombreEmpresa || loading"
              @click="ejecutarProceso"
            >
              Ejecutar proceso
            </v-btn>
          </v-col>
        </v-row>

        <v-alert
          v-if="mensaje"
          :type="tipoMensaje"
          dense
          text
          class="mt-4"
        >
          {{ mensaje }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'JornadaPlusesAEndalia',

  data() {
    return {
      loading: false,
      nombreEmpresa: null,
      mensaje: null,
      tipoMensaje: 'success',
      guardarHistorico: true,

      empresas: [
        'CENTRAL FRANQUICIAS EL RINCON',
        'EL RINCON AMPLIACION, S.L.',
        'EL RINCON CONVENIENCIA, S.L.',
        'FLAMENYCOM SL',
        'FRUTOS SECOS EL RINCON EXTERIORES S.L',
        'FRUTOS SECOS EL RINCON, S.L.',
        'LOFLA, S.L.',
        'MARTIN MARTIN CONVENIENCIA',
        'MARTIN MARTIN ESTE',
        'MARTIN MARTIN NORTE',
        'MOSLOCI S.L.',
        'PASTELERIA ARAGONESA DE CALIDAD, S.L.'
      ]
    }
  },

  methods: {
    async ejecutarProceso() {
      this.loading = true
      this.mensaje = null

      try {
        const token = localStorage.getItem('token')

        const url = 'https://test.azurewebsites.net/api/ops/sync/jornadas-pluses-a-endalia-http'
        //const url = 'https://fc-ne-pro-fapp-api-fc-ajbkc8c3fmczc6dj.northeurope-01.azurewebsites.net/api/ops/sync/jornadas-pluses-a-endalia-http'

        const response = await axios.post(
          url,
          {
            nombreempresa: this.nombreEmpresa,
            guardarHistorico: this.guardarHistorico
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: token
            }
          }
        )

        this.tipoMensaje = 'success'
        this.mensaje = response.data?.message || 'Proceso ejecutado correctamente.'
      } catch (error) {
        console.error(error)

        this.tipoMensaje = 'error'

        if (error.response && error.response.data) {
          this.mensaje = error.response.data.message || error.response.data
        } else {
          this.mensaje = 'Error al ejecutar el proceso.'
        }
      } finally {
        this.loading = false
      }
    }
  }
}
</script>